export enum FilterMethod {
  Equal = '==',
  GreaterThen = '>',
  GreaterThenOrEqual = '>=',
  LessThen = '<',
  LessThenOrEqual = '<=',
  In = 'in',
  ArrayContains = 'array-contains',
  ArrayContainsAny = 'array-contains-any'
}
